import { ReturnHotKeyIcon } from '@modules/common/components/HotKeyIcons';
import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { useHotkey } from '@modules/common/hooks';
import { ArrowBackRounded } from '@mui/icons-material';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
} from '@mui/material';
import { ReactNode } from 'react';

interface IntegrationConfirmationDialogContentProps {
  title: ReactNode;
  content: ReactNode;
  onConfirm: () => void;
}

export const IntegrationConfirmationDialogContent = ({
  title,
  content,
  onConfirm,
}: IntegrationConfirmationDialogContentProps) => {
  const { closeModal } = useMuiModalContext();

  const confirmAndIntegrate = () => {
    onConfirm();
    closeModal();
  };

  useHotkey({
    hotkey: 'enter',
    onHotkey: confirmAndIntegrate,
    isHotKeyDisabled: false,
    actionTitle: 'Confirm Integration Name',
  });

  return (
    <>
      <DialogTitle>{title}</DialogTitle>
      <Divider light />
      <DialogContent>
        <Stack spacing={3}>{content}</Stack>
      </DialogContent>
      <Divider light />
      <DialogActions sx={{ my: 1, mx: 2 }}>
        <Button
          variant="outlined"
          onClick={() => closeModal()}
          startIcon={<ArrowBackRounded />}
        >
          Go Back
        </Button>
        <Button
          variant="contained"
          onClick={confirmAndIntegrate}
          endIcon={<ReturnHotKeyIcon />}
        >
          Confirm And Integrate
        </Button>
      </DialogActions>
    </>
  );
};
